import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  fetchGroupedCustomerData,
  fetchStaffGroupedData,
  fetchStaffGroupedCounts,
  fetchLoginHistory,
  fetchMonthlyReport,
} from "../../slice/GroupDataSlice";
import { Container, Row, Col } from "react-bootstrap";
import { Tabs, Tab, Box } from "@mui/material";
import PageTitle from "../../components/PageTitle";
import DashboardCollections from "../DashboardCollections";
import DashboardSummary from "../DashboardSummary";
import DashboardLoginHistory from "../DashboardLoginHistory";
import DashboardMonthlyReport from "../DashboardMonthlyReport";
import DashboardPlanwiseReport from "../DashboardPlanwiseReport";
import BoxesTable from "../BoxesTable";
import "../listings/Pages.css";

// TabPanel component to render content for each tab
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const Dashboard = () => {
  const [searchText, setSearchText] = useState("");
  const [loginHistorySearchText, setLoginHistorySearchText] = useState("");
  const [showConnectedTable, setShowConnectedTable] = useState(false);
  const [showDisconnectedTable, setShowDisconnectedTable] = useState(false);
  const [showTotalTable, setShowTotalTable] = useState(false);
  const [showUnpaidTable, setShowUnpaidTable] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [month, setMonth] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGroupedCustomerData());
    dispatch(fetchStaffGroupedData());
    dispatch(fetchStaffGroupedCounts());
    dispatch(fetchLoginHistory());
    dispatch(fetchMonthlyReport({ year, month: month || undefined }));
  }, [dispatch, year, month]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div id="main">
      <div className="dashboard p-2">
        <Container className="p-2 mb-3" fluid>
          <Row>
            <Col xs="12" className="py-3">
              <PageTitle PageTitle="Dashboard" showButton={false} />
            </Col>
          </Row>

          {/* Boxes Section */}
          <BoxesTable
            showConnectedTable={showConnectedTable}
            setShowConnectedTable={setShowConnectedTable}
            showDisconnectedTable={showDisconnectedTable}
            setShowDisconnectedTable={setShowDisconnectedTable}
            showTotalTable={showTotalTable}
            setShowTotalTable={setShowTotalTable}
            showUnpaidTable={showUnpaidTable}
            setShowUnpaidTable={setShowUnpaidTable}
          />

          {/* Tabs */}
          <Row>
            <Col xs="12">
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="dashboard tabs"
                  className="custom-tabs"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#1976d2",
                    },
                  }}
                >
                  <Tab
                    label="Collections"
                    id="tab-0"
                    aria-controls="tabpanel-0"
                  />
                  <Tab label="Summary" id="tab-1" aria-controls="tabpanel-1" />
                  <Tab
                    label="Login History"
                    id="tab-2"
                    aria-controls="tabpanel-2"
                  />
                  <Tab
                    label="Monthly Report"
                    id="tab-3"
                    aria-controls="tabpanel-3"
                  />
                  <Tab
                    label="Planwise Report"
                    id="tab-4"
                    aria-controls="tabpanel-4"
                  />
                </Tabs>
              </Box>
              <TabPanel value={tabValue} index={0}>
                <DashboardCollections
                  searchText={searchText}
                  setSearchText={setSearchText}
                  selectedStaffId={selectedStaffId}
                  setSelectedStaffId={setSelectedStaffId}
                  selectedUserId={selectedUserId}
                  setSelectedUserId={setSelectedUserId}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <DashboardSummary
                  searchText={searchText}
                  setSearchText={setSearchText}
                  selectedStaffId={selectedStaffId}
                  setSelectedStaffId={setSelectedStaffId}
                  selectedUserId={selectedUserId}
                  setSelectedUserId={setSelectedUserId}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <DashboardLoginHistory
                  loginHistorySearchText={loginHistorySearchText}
                  setLoginHistorySearchText={setLoginHistorySearchText}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={3}>
                <DashboardMonthlyReport
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
              </TabPanel>
              <TabPanel value={tabValue} index={4}>
                <DashboardPlanwiseReport />
              </TabPanel>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Dashboard;
